import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserClassesTaken } from '@models/user-classes-taken';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { UserClassesService } from '@services/user-classes.service';
import { CourseRestrictionService, RestrictionResult } from '@services/course-restriction.service';
import { ConfigurationService } from '@core/services/configuration.service';
import { UserCourseDto, createUserCourseDto } from '@models/user-course-dto';
import { classItem } from '@models/classItem';
import { UserClassesStateService } from "@services/user-classes-state.service";
import { UserEnrolmentService } from '@core/services/user-enrolment.service';
import { PopupComponent } from '@components/popup/popup.component';
import {ClassesComponent } from '@classes/classes-list/classes.component';
import { utils } from 'xlsx';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-class-card',
  templateUrl: './class-card.component.html',
  styleUrls: ['./class-card.component.css']
})
export class ClassCardComponent implements OnInit {
  @Input() userClassesTaken: UserClassesTaken;
  @Input() userClass: classItem;
  @Input() userClassesTakenList: UserClassesTaken[];

  //class_number: number; 
  userClasses: UserClassesTaken; // to update the handout
  userClassesTaken1: UserClassesTaken;
  userCourseDto: UserCourseDto; // Store enrollment data
  courseCompleted: number; // Store course completion count
  pageErrors: any = false;
  pageErrorsText: string = "";
  pageErrorsText1: string = "";
  pageErrorsLink: string = "";


  constructor(
    private router: Router, 
    private alertify: AlertifyService,
    public authService: AuthService, 
    private userClassesService: UserClassesService,  
    private dialogRef: MatDialog,
    private courseRestrictionService: CourseRestrictionService,
    private configurationService: ConfigurationService,
    private userClassesStateService: UserClassesStateService,
    private userEnrolmentService: UserEnrolmentService
  ) { }

  ngOnInit(): void {
    //this.class_number = this.userClassesTaken.classId;
    // this.userClassesTakenList.classId
    // userClassTakenList1
    // this.userClassesTaken = this.userClassesTakenList[+this.userClass.id];
    // console.log("Here: " + this.userClassesTaken.classId);
    // Initialize user classes state
    this.userClassesStateService.loadUserClasses().subscribe();
    
    // Initialize enrollment data once on component load
    this.initializeEnrollmentData();
  }

  private initializeEnrollmentData(): void {
    this.userEnrolmentService.getEnrollmentDataWithFallback().subscribe(enrollmentData => {
      this.userCourseDto = enrollmentData;
      
      // Get initial course completion status
      this.userClassesService.CheckAllClassesComplete(enrollmentData).subscribe((courseCompleted: number) => {
        this.courseCompleted = courseCompleted;
        this.updateProgressDisplay();
      });
    });
  }

  // called by getHandout() after marking handout as completed to refresh enrollment data and update progress display
  private refreshEnrollmentAndProgress(): void {
    // Force refresh enrollment data from API (bypasses cache)
    this.userEnrolmentService.refreshEnrollmentData().subscribe(enrollmentData => {
      this.userCourseDto = enrollmentData;
      
      // Get updated completion status using fresh enrollment data
      this.userClassesService.CheckAllClassesComplete(enrollmentData).subscribe((courseCompleted: number) => {
        this.courseCompleted = courseCompleted;
        this.updateProgressDisplay();
      });
    });
  }

  private updateProgressDisplay(): void {
    // Set percentage
    let percentageWatched = this.courseCompleted * 100 / 30;
    localStorage.setItem('percentage', percentageWatched.toString());
    
    // Check if course is complete
    if (this.configurationService.isCourseComplete(this.courseCompleted)) {
      if (this.authService.getCourseCompleted() == "false") {
        this.alertify.success('You have completed the course Intercessory Prayer !');
        this.authService.setCourseCompleted(); 
      }
    }
  }

  myFunction() {
    alert(this.userClass.id);
    // this.userClass.title
    // this.userClassesTaken.isQuizCompleted
    // this.userClassesTaken.isHandoutCompleted
    
  }

  getRestrictions(activity: number): boolean {
    const result = this.courseRestrictionService.checkAccess(
      this.userClass.id, 
      activity, 
      this.userClassesTakenList
    );

    if (!result.canAccess) {
      this.pageErrors = true;
      this.pageErrorsText = result.errorMessage || "";
      this.pageErrorsText1 = result.errorMessage2 || "";
      this.pageErrorsLink = result.redirectLink || "";
      return false;
    }

    // Clear any previous errors
    this.pageErrors = false;
    this.pageErrorsText = "";
    this.pageErrorsText1 = "";
    this.pageErrorsLink = "";
    
    return true;
  }

   get_video() {
    const result = this.courseRestrictionService.canAccessVideo(this.userClass.id, this.userClassesTakenList);

    if (result.canAccess) {
      let rlink = "/app/video/" + this.userClass.id;
      this.router.navigate([rlink, { id: this.userClass.id }], {fragment: 'top'});
    } else {
      this.pageErrors = true;
      this.pageErrorsText = result.errorMessage || "";
      this.pageErrorsText1 = result.errorMessage2 || "";
      this.pageErrorsLink = result.redirectLink || "";
      this.openDialog("Errors!Video");
    }
   }
   get_handout() {
    const result = this.courseRestrictionService.canAccessHandout(this.userClass.id, this.userClassesTakenList);

    if (result.canAccess) {
      window.open(this.getHandout());
    } else {
      this.pageErrors = true;
      this.pageErrorsText = result.errorMessage || "";
      this.pageErrorsText1 = result.errorMessage2 || "";
      this.pageErrorsLink = result.redirectLink || "";
      this.openDialog("Errors!Handout");
    }
   }
   get_quiz() { 
    const result = this.courseRestrictionService.canAccessQuiz(this.userClass.id, this.userClassesTakenList);

    if (result.canAccess) {
      let rlink = "/app/quiz/" + this.userClass.id;
      this.router.navigate([rlink, { id: this.userClass.id }], {fragment: 'top'});
    } else {
      this.pageErrors = true;
      this.pageErrorsText = result.errorMessage || "";
      this.pageErrorsText1 = result.errorMessage2 || "";
      this.pageErrorsLink = result.redirectLink || "";
      this.openDialog("Errors!Quiz");
    }
   }

  getHandout() {
    // console.log(this.authService.returnCurrentUser().id);
     let classId = this.userClass.id;

     // added class state service
     const currentClassState = this.userClassesStateService.getClassById(classId);

     this.userClasses = {
       classId: classId,
       userId: this.authService.returnCurrentUser().id, //this.authService.returnCurrentUser().id,
       videoLength: currentClassState?.videoLength || 0,  //this.videoDuration / 60,
       videoWatched: currentClassState?.videoWatched || 0, //this.currentVideoTime / 60,
       isQuizCompleted: currentClassState?.isQuizCompleted || false,
       isVideoCompleted: currentClassState?.isVideoCompleted || null,
       isHandoutCompleted : true,
       whenClassStarted: currentClassState?.whenClassStarted || null,
       whenClassCompleted: currentClassState?.whenClassCompleted || null,
       isAvailable: currentClassState?.isAvailable || false,
     };

     this.userClassesService.UpdateUserClassesTakenVideoCompleted(this.userClasses).subscribe(next => {
     //console.log(this.userClasses);
     }, error => {
       this.alertify.error(error);
     }, () => {
       // After updating handout completion, refresh enrollment data and check progress
       this.refreshEnrollmentAndProgress();
     });
     
     //console.log("error 4");
    //  let checkHandout = document.getElementById("checkHandout" + classId.toString()) as HTMLImageElement;
    //  checkHandout.src = "../../assets/checkmark-check.png";
    this.userClassesTaken.isHandoutCompleted = true;
    //  https://fliphtml5.com/qubm/rlzm 
    //  return '../../assets/handout/Session_' + classId + '_Handout_Online.pdf';
    
    // Get class-specific document URL from configuration service
    const documentUrl = this.configurationService.getClassDocumentUrl(classId);
    return documentUrl;
  }

   // include the character %
  getPercentageVideoWatchedText() {
    // this.listlengthVideos.set(classTaken.id, classTaken.videoLength);
    // this.listLengthWatchedVideos.set(classTaken.classId, classTaken.videoWatched);

    let lengthVideo = this.userClassesTaken.videoLength;//this.listlengthVideos.get(classId); 
    let videoWatched = this.userClassesTaken.videoWatched;//this.listLenghtWatchedVideos.get(classId);
    if (lengthVideo != null && videoWatched != null && lengthVideo != 0) {
      return ((videoWatched * 100) / lengthVideo ).toFixed(0).toString()  + ' % ';
    }
  }

  getPercentageVideoWatched() {
    let lengthVideo = this.userClassesTaken.videoLength;
    let videoWatched = this.userClassesTaken.videoWatched;
    if (lengthVideo != null && videoWatched != null && lengthVideo != 0) {
      return (videoWatched * 100) / lengthVideo;
    }
  }

  /**
   * Helper methods for improved template accessibility
   */
  canAccessVideo(): boolean {
    return this.courseRestrictionService.canAccessVideo(this.userClass.id, this.userClassesTakenList).canAccess;
  }

  canAccessHandout(): boolean {
    return this.courseRestrictionService.canAccessHandout(this.userClass.id, this.userClassesTakenList).canAccess;
  }

  canAccessQuiz(): boolean {
    return this.courseRestrictionService.canAccessQuiz(this.userClass.id, this.userClassesTakenList).canAccess;
  }

  openDialog(s: string) {
    this.dialogRef.open(PopupComponent, {
      data : {
        pageErrorsText : this.pageErrorsText,
        pageErrorsText1 : this.pageErrorsText1,
        pageErrorsLink : this.pageErrorsLink
      }
    });
  }

}
